export const passwordRegex = {
  hasUppercase: /[A-Z]/,
  hasLowercase: /[a-z]/,
  hasNumeric: /[0-9]/,
  hasSpecialCharacter: /[^A-Za-z 0-9]/g
}
